/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/DataVaxiomProfessionalView/Content/Details/Office/Name",
  isInvalid,
  onChange
  
}) {
let searchViewDetailsLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'search',
path: 'view_details.location.name',
})
let searchViewDetailsLocationNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'search',
path: 'view_details.location.name',
validate: fromValidate.textInput,
required: true,
})
let searchViewDetailsLocationNameChangeData = fromData.useDataChange({ viewPath,
context: 'search',
path: 'view_details.location.name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 disabled={true}
 data="search.view_details.location.name"
 validate="/Data/validate.js textInput"
 required={true}
 invalid={!searchViewDetailsLocationNameIsValidData}
 value={searchViewDetailsLocationNameValueData}
 onChange={searchViewDetailsLocationNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Office Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}